import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AuthProvider } from '@/lib/auth'
import { ToastProvider } from '@/ui/Toast'
import { initPeau } from '@/lib/peau'
import './styles/base.css'

// Avant le premier rendu : sinon la page s'affiche dans une peau puis saute
// dans l'autre.
initPeau()

const racine = document.getElementById('root')
if (!racine) throw new Error('#root introuvable')

createRoot(racine).render(
  <StrictMode>
    <ToastProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ToastProvider>
  </StrictMode>,
)
